const SUBJECT_MAP: Record<string, string> = {
  mathematics: "math",
  maths: "math",
  physics: "physics",
  chemistry: "chemistry",
  biology: "science",
  english: "english",
};

/** Maps API subject display name to generate-solution `subject` slug (mobile ChatModule). */
export function mapSubjectNameToApiSubject(name: string): string {
  const raw = name.trim().toLowerCase();
  return SUBJECT_MAP[raw] ?? raw;
}

export function getDoubtRequestPlatform(): "WEB" {
  return "WEB";
}
